import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetAllPaymentsQuery } from '../redux/api/roomBookingApi';

const AdminPayments = () => {
    const navigate = useNavigate();
    const { data: paymentsData, isLoading, error } = useGetAllPaymentsQuery();

    if (isLoading) return <div className="container py-5 text-center">Loading All Payments...</div>;
    if (error) return <div className="container py-5 text-center text-danger">Error loading payments or access denied.</div>;

    return (
        <div className="space-top space-extra-bottom">
            <div className="container">
                <div className="card shadow-sm">
                    <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                        <h4 className="mb-0 text-white">Admin: All Payments Helper</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {paymentsData && paymentsData.data && paymentsData.data.length > 0 ? (
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark">
                                        <tr style={{ color: '#fff' }}>
                                            <th>Date</th>
                                            <th>User</th>
                                            <th>Transaction ID</th>
                                            <th>Booking ID</th>
                                            <th>Amount</th>
                                            <th>Method</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentsData.data.map((payment) => (
                                            <tr key={payment._id}>
                                                <td>{new Date(payment.created_date).toLocaleString()}</td>
                                                <td>
                                                    {payment.user_id ? (
                                                        <div>
                                                            <strong>{payment.user_id.name}</strong>
                                                            <br />
                                                            <small className="text-muted">{payment.user_id.email}</small>
                                                        </div>
                                                    ) : (
                                                        <span className="text-muted">Guest / Deleted</span>
                                                    )}
                                                </td>
                                                <td><small>{payment.transaction_id}</small></td>
                                                <td><small>{payment.booking_id}</small></td>
                                                <td>₹{payment.amount}</td>
                                                <td>{payment.pay_id || 'N/A'}</td>
                                                <td>
                                                    <span className={`badge bg-${payment.pay_status === 'completed' ? 'success' : 'danger'}`}>
                                                        {payment.pay_status.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => navigate(`/admin/order-details/${payment._id}`)}
                                                        className="btn btn-sm btn-light"
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <p className="text-center py-4">No payments found in the system.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPayments;
